import {HistoryPaginatorBaseModel} from "./history-paginator-base.model";
import {NextHistoryPageRequest, SessionHistoryRecordRawData} from "../../gaming-history.service.interfce";
import {
    HistoryController_GetGameSessionHistoryResponse
} from "../../../api/api.service";
import {SessionGamingHistoryRecordModel} from "../record/session-gaming-history-record.model";
import {GameInfo} from "../../../games/game-info";
import {ILegacyCompanyViewModel} from "../../../companies/legacy-company-view-model.interface";

export class SessionGamingHistoryPaginatorModel extends HistoryPaginatorBaseModel<SessionHistoryRecordRawData, HistoryController_GetGameSessionHistoryResponse, SessionGamingHistoryRecordModel> {
    protected _createRecordModel(gameInfo: GameInfo, company: ILegacyCompanyViewModel, recordData: SessionHistoryRecordRawData): SessionGamingHistoryRecordModel {
        return new SessionGamingHistoryRecordModel(this.services, gameInfo, company, recordData);
    }

    protected _getGameTypeFromRecord(recordData: SessionHistoryRecordRawData): number {
        return recordData.GameTypeId;
    }

    protected async _getNextPage(request: NextHistoryPageRequest): Promise<HistoryController_GetGameSessionHistoryResponse> {
        return  await this.services.api.historyController.getGameSessionHistory(request);
    }

    protected _getRoundIdFromRecord(recordData: SessionHistoryRecordRawData): string {
        return recordData.GameSessionId;
    }
}